import { createRouter, createWebHistory } from 'vue-router'
import ShipView from '@/views/ships/ShipView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import { useShipStore } from '@/stores/ship'
import { authRoutes } from '@haskoning/vue-authentication-middleware'
import { useAuthenticationStore } from '@/stores/authentication'
import { storeToRefs } from 'pinia'

export const INDEX_ROUTES = {
	NOT_FOUND: {
		name: 'not-found',
		path: '/:pathMatch(.*)*'
	},
	HOME: {
		name: 'home',
		path: '/',
		AUTH: {
			name: 'auth-login'
		}
	},
	SHIP: {
		name: 'ship-index',
		path: '/SHIP'
	}
}

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: INDEX_ROUTES.NOT_FOUND.path,
			name: INDEX_ROUTES.NOT_FOUND.name,
			component: NotFoundView
		},
		{
			path: INDEX_ROUTES.HOME.path,
			name: INDEX_ROUTES.HOME.name,
			redirect: {
				name: INDEX_ROUTES.HOME.AUTH.name
			}
		},
		authRoutes,
		{
			path: INDEX_ROUTES.SHIP.path,
			name: INDEX_ROUTES.SHIP.name,
			component: ShipView,
			beforeEnter: (to, from) => {
				const store = useShipStore()
				store.resetState()
				return true
			}
		}
	]
})

router.beforeEach(async (to) => {
	const authStore = useAuthenticationStore()
	const { user } = storeToRefs(authStore)

	if (!user.value?.id) {
		await authStore.reAuthenticate()
	}
	if (typeof to.name !== 'string' || to.name?.startsWith('auth-')) {
		if (user.value) {
			return { name: INDEX_ROUTES.SHIP.name }
		}
		return true
	}
	// check auth and apply login redirect
	if (!user.value) {
		return { name: INDEX_ROUTES.HOME.AUTH.name }
	}
	return true
})

export default router
